import { EntityRequestAprv } from "../../entity/EntityRequestAprv";

export class DtoRequestAprvsPutRes extends EntityRequestAprv {}
